import { Injectable, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserInfo } from './userInfo';

@Injectable({
  providedIn: 'root'
})
  export class DataService implements OnInit{
 

  public envUrl = "assets/data.json";
  public userJson: any = [];

  private Corsheaders = { 'Access-Control-Allow-Origin': 'http://localhost:4200',  
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
  'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, Authorization',
  'Access-Control-Allow-Credentials':'true'
  };


 

  constructor(private http:HttpClient ) { 
   
  }
  

 public getUserJson(){
   return  this.http.get("assets/data.json")
  }
  

  ngOnInit(): void {
    console.log("service");
    // this.http.get(this.envUrl).subscribe(data =>{
    //   this.userJson = data;
    // });
  }

  public load(): Promise<any> {
    console.log("load call");
    return new Promise((resolve, reject) => {
      this.http.get(this.envUrl).subscribe((response: any) => {
        console.log("load result");
          this.userJson = response;
          resolve(true);
        }, err=>{
          console.log(err);
          reject(err);
        });
     });
  }
  public loadpromise():any{
    console.log("loadpromise call");
    const promise = new Promise((resolve, reject)=> {
      this.http.get(this.envUrl).toPromise().then((result:any) => {
        console.log("loadpromise result");
        this.userJson = result;
        resolve(true);
      }, err =>{
      console.log(err);
      reject(err);
      })
    });
    return promise;
  }
  
  public prom():void{
    this.http.get(this.envUrl)
    .toPromise()
    .then((data:any) =>{
      this.userJson = data;
    }, _err=>{
      
    });
  }

  getData(result):Observable<UserInfo>
  {
    let data = new Observable<UserInfo>(observer => {
              observer.next(result);
    });
    return data;
  }

  getStoreLocation()  {


    let s =  new HttpHeaders({ 'Access-Control-Allow-Origin': '*' });
    
    return this.http.get(this.userJson.LocationUrl,   {headers:  this.Corsheaders});
  }


}